import { render } from "./ErrorModal.vue?vue&type=template&id=fac9615c&ts=true"
import script from "./ErrorModal.vue?vue&type=script&lang=ts"
export * from "./ErrorModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__